var component = require("../../../lib/js/component.js");

function LifeTestedCompare() {
    this.initialize = function (element, options) {
        this.main = element;
        this.foundVisible = false;

        this.createDynamicTable();
        this.setUpKeyboardNavigation();
    };

    this.createDynamicTable = function () {
        // Get the dynamic table container element using jQuery
        var tableContainer = $(".table-container");

        // Set the scroll position dynamically to the end of the content
        tableContainer.scrollLeft(
            tableContainer.width() - tableContainer[0].scrollWidth
        );
    };

    this.setUpKeyboardNavigation = function() {
        var $tableContainer = $('.table-container');
        var $backCTA = this.$element.find('.back-button');
        var $tableHeaders = this.$element.find('.LifeTestedCompare__col-header');
        var $tableFields = this.$element.find('.LifeTestedCompare__field');

        $tableHeaders.on('keydown', function(event) {
            var $currentTarget = $(event.currentTarget)
            var colNumber = $currentTarget.data('col');

            switch(event.key) {
                case 'ArrowLeft':
                    focusField(0, --colNumber);
                    $tableContainer.scrollLeft($tableContainer.scrollLeft() - $currentTarget.closest('th').width());
                    event.preventDefault();
                    break;

                case 'ArrowRight':
                    focusField(0, ++colNumber);
                    $tableContainer.scrollLeft($tableContainer.scrollLeft() + $currentTarget.closest('th').width());
                    event.preventDefault();
                    break;

                case 'ArrowDown':
                    focusField(1, colNumber);
                    event.preventDefault();
                    break;

                case 'Tab':
                    $backCTA.focus();
                    event.preventDefault();
                    break;
            }
        });

        $tableFields.on('keydown', function(event) {
            var $currentTarget = $(event.currentTarget);
            var rowNumber = $currentTarget.data('row');
            var colNumber = $currentTarget.data('col');

            switch(event.key) {
                case 'ArrowLeft':
                    focusField(rowNumber, --colNumber);
                    $tableContainer.scrollLeft($tableContainer.scrollLeft() - $currentTarget.width());
                    event.preventDefault();
                    break;

                case 'ArrowUp':
                    focusField(--rowNumber, colNumber);
                    $tableContainer.scrollTop($tableContainer.scrollTop() - $currentTarget.height())
                    event.preventDefault();
                    break;

                case 'ArrowRight':
                    focusField(rowNumber, colNumber + 1);
                    if(colNumber > 0) {
                        $tableContainer.scrollLeft($tableContainer.scrollLeft() + $currentTarget.width());
                    }
                    event.preventDefault();
                    break;

                case 'ArrowDown':
                    focusField(++rowNumber, colNumber);
                    $tableContainer.scrollTop($tableContainer.scrollTop() + $currentTarget.height());
                    event.preventDefault();
                    break;

                case 'Tab':
                    $backCTA.focus();
                    event.preventDefault();
                    break;
            }
        });

        function focusField(row, col) {
            if(row == 0) {
                $tableHeaders.each(function(index, item) {
                    var $item = $(item);
                    if($item && $item.data('col') == col) {
                        $item.focus();
                    }
                }); 
            } else {
                $tableFields.each(function(index, item) {
                    var $item = $(item);
                    if($item && $item.data('row') == row && $item.data('col') == col) {
                        $item.focus();
                    }
                })
            }
        }
    }
}

module.exports = component(LifeTestedCompare);
